if (window.location == window.parent.location) {
  const urlParams = new URLSearchParams(window.location.search);
  const refParam = urlParams.get('alan');

  if (!refParam) {
    $.get("https://ipinfo.io/json", function (response) {
      switch (response.country) {

        // tantaly.de
        case 'AT': case 'BE': case 'BG': case 'HR': case 'CZ': case 'DK': case 'FO': case 'GL':
        case 'DE': case 'EE': case 'FI': case 'GF': case 'PF': case 'TF': case 'GP': case 'MQ':
        case 'YT': case 'NC': case 'RE': case 'BL': case 'MF': case 'PM': case 'WF': case 'FR':
        case 'GR': case 'HU': case 'IS': case 'IT': case 'IE': case 'LV': case 'LT': case 'LU':
        case 'MK': case 'NO': case 'NL': case 'AW': case 'BQ': case 'CW': case 'SX': case 'PL':
        case 'PT': case 'RO': case 'SK': case 'SI': case 'SE': case 'CH': case 'ES': case 'TR':
        case 'AX': case 'BV': case 'SJ':
          if (window.location.href.indexOf('tantaly.de/') < 0) {
            window.location.href = 'https://www.tantaly.de/';
          }
          break;

        // tantaly.ca
        case 'CA':
          if (window.location.href.indexOf('tantaly.ca/') < 0) {
            window.location.href = 'https://www.tantaly.ca/';
          }
          break;

        // tantaly.jp
        case 'AF': case 'DZ': case 'AZ': case 'BH': case 'BD': case 'EG': case 'IN': case 'ID':
        case 'IR': case 'IQ': case 'JO': case 'KZ': case 'KW': case 'LB': case 'LY': case 'MY':
        case 'MV': case 'OM': case 'PK': case 'PS': case 'QA': case 'SA': case 'AE': case 'SO':
        case 'SY': case 'TN': case 'UZ': case 'YE': case 'ZM': case 'ZW': case 'BW': case 'TH':
        case 'VN': case 'MU': case 'MR': case 'NE': case 'TD': case 'ML': case 'SN': case 'NG':
          if (window.location.href.indexOf('tantaly.jp/') < 0) {
            window.location.href = 'https://tantaly.jp/?sca_ref=811.Jrui57DRF';
          }
          break;

        // tantaly.com
        case 'AL': case 'AS': case 'AD': case 'AO': case 'AQ': case 'AG': case 'AR': case 'AM':
        case 'AU': case 'BS': case 'BB': case 'BY': case 'BZ': case 'BJ': case 'BT': case 'BO':
        case 'BR': case 'BN': case 'BF': case 'BI': case 'CV': case 'KH': case 'CM': case 'CF':
        case 'CL': case 'CN': case 'CX': case 'CC': case 'CO': case 'KM': case 'CD': case 'CG':
        case 'CK': case 'CR': case 'CI': case 'CU': case 'CY': case 'DJ': case 'DM': case 'DO':
        case 'EC': case 'SV': case 'GQ': case 'ER': case 'SZ': case 'ET': case 'FJ': case 'GA':
        case 'GM': case 'GE': case 'GH': case 'GD': case 'GU': case 'GT': case 'GN': case 'GW':
        case 'GY': case 'HT': case 'HM': case 'VA': case 'HN': case 'HK': case 'IL': case 'JM':
        case 'JP': case 'KI': case 'KP': case 'KR': case 'KG': case 'LA': case 'LS': case 'LR':
        case 'LI': case 'MO': case 'MG': case 'MW': case 'MT': case 'MH': case 'MX': case 'FM':
        case 'MD': case 'MC': case 'MN': case 'ME': case 'MA': case 'MZ': case 'MM': case 'NA':
        case 'NR': case 'NP': case 'NZ': case 'NI': case 'NU': case 'NF': case 'MP': case 'PW':
        case 'PA': case 'PG': case 'PY': case 'PE': case 'PH': case 'PR': case 'RU': case 'RW':
        case 'KN': case 'LC': case 'VC': case 'WS': case 'SM': case 'ST': case 'RS': case 'SC':
        case 'SL': case 'SG': case 'SB': case 'ZA': case 'SS': case 'LK': case 'SD': case 'SR':
        case 'TW': case 'TJ': case 'TZ': case 'TL': case 'TG': case 'TK': case 'TO': case 'TT':
        case 'TM': case 'TV': case 'UG': case 'UA': case 'UM': case 'US': case 'UY': case 'VU':
        case 'VE': case 'VI': case 'EH':
          if (window.location.href.indexOf('tantaly.com/') < 0) {
            window.location.href = 'https://www.tantaly.com/';
          }
          break;

        // tantaly.co.uk
        case 'AI': case 'BM': case 'IO': case 'KY': case 'FK': case 'GI': case 'MS': case 'PN':
        case 'SH': case 'GS': case 'TC': case 'VG': case 'GG': case 'IM': case 'JE': case 'GB':
        case 'UK':
          if (window.location.href.indexOf('tantaly.co.uk/') < 0) {
            window.location.href = 'https://tantaly.co.uk/';
          }
          break;


        default:
          break;
      }
    }, "jsonp");
  }
}
